import JoyObject from './JoyObject';
import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyDataService from '../services/JoyDataService';
import { isJoyUserRoleMap, isJoyPropertiesArray } from '../validation/ModelValidation';
import { isString, isDate, isBoolean, isEmailArray, isUrl, isPhone, isEmail, } from '../validation/TypeChecking';
import { compareUserRoleMaps, compareProps, compareStringArrays } from '../utils/Utils';
export default class JoyUser extends JoyObject {
    /**
     * Create a new JoyUser object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: '',
        });
        this.fields = [
            JoyField.primaryEmail,
            JoyField.name,
            JoyField.password,
            JoyField.emails,
            JoyField.groups,
            JoyField.props,
            // JoyField.storageUsed,
            JoyField.photoUrl,
            JoyField.birthday,
            JoyField.phone,
        ];
        this.objectType = JoyObjectType.user;
        this.update = (update) => {
            console.log('new updates for user: ' + this.id);
            let changes = [];
            let email = update[JoyField.primaryEmail];
            if (isEmail(email) && this._primaryEmail !== email) {
                this._primaryEmail = email;
                changes.push(JoyField.primaryEmail);
            }
            let name = update[JoyField.name];
            if (isString(name) && this._name !== name) {
                this._name = name;
                changes.push(JoyField.name);
            }
            let hasPassword = update[JoyField.password];
            if (isBoolean(hasPassword) && this._hasPassword !== hasPassword) {
                this._hasPassword = hasPassword;
                changes.push(JoyField.password);
            }
            let emails = update[JoyField.emails];
            if (isEmailArray(email) && !compareStringArrays(emails, this._emails)) {
                this._emails = emails;
                changes.push(JoyField.emails);
            }
            let groups = update[JoyField.groups];
            if (isJoyUserRoleMap(groups) && !compareUserRoleMaps(this._groups, groups)) {
                this._groups = groups;
                changes.push(JoyField.groups);
            }
            let properties = update[JoyField.props];
            if (isJoyPropertiesArray(properties) && compareProps(this._properties, properties)) {
                this._properties = properties;
                changes.push(JoyField.props);
            }
            // let storageUsed = update[JoyField.storageUsed];
            // if (isNumber(storageUsed) && this._storageUsed !== storageUsed) {
            //   this._storageUsed = storageUsed;
            //   changes.push(JoyField.storageUsed);
            // }
            let photoUrl = update[JoyField.photoUrl];
            if (isUrl(photoUrl)) {
                let exists = isUrl(this._photoUrl);
                if (!exists || (exists && this.photoUrl !== photoUrl)) {
                    this._photoUrl = photoUrl;
                    changes.push(JoyField.photoUrl);
                }
            }
            let birthday = update[JoyField.birthday];
            if (isDate(birthday)) {
                let exists = isDate(this._birthday);
                if (!exists || (exists && this._birthday !== birthday)) {
                    this._birthday = birthday;
                    changes.push(JoyField.birthday);
                }
            }
            let phone = update[JoyField.phone];
            if (isPhone(phone)) {
                let exists = isPhone(this._phone);
                if (!exists || (exists && this._phone !== phone)) {
                    this._phone = phone;
                    changes.push(JoyField.phone);
                }
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.primaryEmail])) {
            throw Error('Invalid field primaryEmail.');
        }
        this._primaryEmail = data[JoyField.primaryEmail];
        if (!isString(data[JoyField.name])) {
            throw Error('Invalid field name.');
        }
        this._name = data[JoyField.name];
        if (!isBoolean(data[JoyField.password])) {
            throw Error('Invalid field password.');
        }
        this._hasPassword = data[JoyField.password];
        if (!isEmailArray(data[JoyField.emails])) {
            throw Error('Invalid field emails.');
        }
        this._emails = data[JoyField.emails];
        if (!isJoyUserRoleMap(data[JoyField.groups])) {
            throw Error('Invalid field groups.');
        }
        this._groups = data[JoyField.groups];
        if (!isJoyPropertiesArray(data[JoyField.props])) {
            throw Error('Invalid field props.');
        }
        this._properties = data[JoyField.props];
        // if (!isNumber(data[JoyField.storageUsed])) {
        //   throw Error('Invalid field storageUsed.');
        // }
        // this._storageUsed = data[JoyField.storageUsed];
        if (isUrl(data[JoyField.photoUrl])) {
            this._photoUrl = data[JoyField.photoUrl];
        }
        else {
            this._photoUrl = null;
        }
        if (isDate(data[JoyField.birthday])) {
            this._birthday = data[JoyField.birthday];
        }
        else {
            this._birthday = null;
        }
        if (isPhone(data[JoyField.phone])) {
            this._phone = data[JoyField.phone];
        }
        else {
            this._phone = null;
        }
        this.initialUpdate = JoyUser.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get primaryEmail() {
        return this._primaryEmail;
    }
    get name() {
        return this._name;
    }
    get hasPassword() {
        return this._hasPassword;
    }
    get emails() {
        return this._emails;
    }
    get groups() {
        return this._groups;
    }
    get properties() {
        return this._properties;
    }
    // get storageUsed() {
    //   return this._storageUsed;
    // }
    get photoUrl() {
        return this._photoUrl;
    }
    get birthday() {
        return this._birthday;
    }
    get phone() {
        return this._phone;
    }
    // Helpers
    /**
     * Set the name field of the document.
     * @param name A string.
     */
    async setName(name) {
        let data = new Map();
        data[JoyField.name] = name;
        return this.updateData(data);
    }
    /**
     * Set the password field of the document.
     * @param password The new password, string.
     * @param currentPassword The current password, string.
     */
    async setPassword(password, currentPassword) {
        let data = new Map();
        data[JoyField.password] = password;
        data[JoyField.oldPassword] = currentPassword;
        return this.updateData(data);
    }
    /**
     * Set the primaryEmail field of the document.
     * @param email A string representing a valid email address.
     */
    async setPrimaryEmail(email) {
        let data = new Map();
        data[JoyField.primaryEmail] = email;
        return this.updateData(data);
    }
    /**
     * Set the emails field of the document.
     * @param emails An array of strings, each representing a valid email address.
     */
    async setEmails(emails) {
        let data = new Map();
        data[JoyField.emails] = emails;
        return this.updateData(data);
    }
    /**
     * Set both the emails and primaryEmail fields of the document.
     * @param emails An array of strings, each representing a valid email address.
     * @param primaryEmail The new value of the primaryEmail field, a string representing a valid email address. This value must be found in the emails array.
     */
    async setEmailsAndPrimaryEmail(emails, primaryEmail) {
        let data = new Map();
        data[JoyField.emails] = emails;
        data[JoyField.primaryEmail] = primaryEmail;
        return this.updateData(data);
    }
    /**
     * Set the photoUrl field of the document.
     * @param uri A string representing a valid URL.
     */
    async setPhotoUrl(uri) {
        let data = new Map();
        data[JoyField.photoUrl] = uri;
        return this.updateData(data);
    }
    /**
     * Set the birthday field of the document.
     * @param birthday A date.
     */
    async setBirthday(birthday) {
        let data = new Map();
        data[JoyField.birthday] = birthday;
        return this.updateData(data);
    }
    /**
     * Set the phone field of the document.
     * @param phone A string.
     */
    async setPhone(phone) {
        let data = new Map();
        data[JoyField.phone] = phone;
        return this.updateData(data);
    }
}
//# sourceMappingURL=JoyUser.js.map